import React from 'react'

import classNames from 'classnames'

import { IconWrapper } from '../components'

export const IconPackage = ({
  size,
  color,
  className,
  ...props
}: React.ComponentPropsWithoutRef<'svg'> & {
  size?: string | number
}) => (
  <IconWrapper {...props} className={classNames(className, "icon-centivo", "icon-centivo--package")} iconColor={color} size={size} width="24px" height="24px" viewBox="0 0 24 24" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink">

      <defs>
          <path d="M13.3350726,0.313408293 L21.3350725,4.31340822 C22.354559,4.82000324 22.9994684,5.85999226 23.0000726,6.99893886 L23.0000726,16.5294695 C22.9994684,17.6678855 22.354559,18.7078745 21.3372862,19.2133661 L13.3375726,23.2132228 C12.4925207,23.6360871 11.4976245,23.6360871 10.652859,23.2133661 L2.65009682,19.2119796 C1.63158543,18.698783 0.992159815,17.6524502 1,16.5189389 L1,6.99840822 C1.00067683,5.85999226 1.64558623,4.82000324 2.66285901,4.31451167 L6.47223497,2.40942821 C6.52106308,2.3791535 6.57230498,2.35320661 6.62531974,2.33180119 L10.6650726,0.313408293 C11.5060215,-0.104469431 12.4941237,-0.104469431 13.3350726,0.313408293 Z M3,7.377 L3.00002404,16.5258981 C2.99740272,16.906055 3.21054459,17.2548326 3.5472862,17.4245117 L11,21.151 L11,11.377 L3,7.377 Z M21,7.377 L13,11.377 L13,21.145 L20.4450727,17.4234082 C20.7849016,17.2545432 20.9998714,16.9078802 21.0000727,16.5289389 L21,7.377 Z M7.005,4.379 L4.241,5.761 L12.0000726,9.64090487 L14.763,8.259 L7.005,4.379 Z M11.5572862,2.10336605 L9.241,3.261 L17,7.14 L19.758,5.761 L12.4441545,2.10401382 C12.1640373,1.96517702 11.8350854,1.96532769 11.5572862,2.10336605 Z" id="icon--centivo--package"/>
      </defs>
      <g id="Icons" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
          <g transform="translate(-1565.000000, -860.000000)"/>
          <g id="Icon/package">
              <mask id="mask-2" fill="white">
                  <use xlinkHref="#icon--centivo--package"/>
              </mask>
              <use id="Shape" fill="currentColor" xlinkHref="#icon--centivo--package"/>
          </g>
      </g>
  </IconWrapper>
)
